import UrlBaseProvider from "./urlBaseProvider";

export default class PreferenceProvider extends UrlBaseProvider {
	constructor($http, storage, eventBus) {
		super("preference", "/v2/preferences", $http, storage, eventBus);
	}
}
